import React, { useState, lazy, Suspense } from 'react';
import {
    BrowserRouter,
    Routes,
    Route
} from 'react-router-dom';

import {ProtectedRouter} from './ProtectedRouter';

import { AuthService } from "../services/AuthService";
import {Spin} from "antd";
import {PublicRouter} from "./PublicRouter";

export const AppRouter = () => {

    const LoginPage = lazy(() => import('../../pages/LoginPage').then(m => ({ default: m.LoginPage})));
    const HomePage  = lazy(() => import('../../pages/HomePage').then(m => ({ default: m.HomePage})));
    const RecoveryAccountPage   = lazy(() => import('../../pages/RecoveryAccountPage').then(m => ({ default: m.RecoveryAccountPage})));
    const ChangePassAccountPage = lazy(() => import('../../pages/ChangePassAccountPage').then(m => ({ default: m.ChangePassAccountPage})));

    const [ isLoggedIn, setIsLoggedIn ] = useState(false); // todo cambiar a false

    AuthService.getIsLogged().subscribe(({user}) => {
        if (user?.access_token) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false); // todo cambiar a false
        }
    });

    return (
        <>
            <BrowserRouter>
                <Suspense fallback={<Spin/>}>
                    <Routes>

                        <Route element={<PublicRouter/>}>
                            <Route path="/" element={<LoginPage/>}/>
                            <Route path="/recovery" element={<RecoveryAccountPage/>}/>
                            <Route path="/change-password" element={<ChangePassAccountPage/>}/>
                        </Route>

                        <Route element={<ProtectedRouter isLoggedIn={isLoggedIn}/>}>
                            <Route path="/home" element={<HomePage/>}/>
                        </Route>

                    </Routes>
                </Suspense>
            </BrowserRouter>
        </>
    )
}
